import '@/js/main';

// atoms
import '@/components/atoms/swipe-content';

// molecules
import '@/components/molecules/slideshow';
